module.exports = __webpack_public_path__ + "img/blockS4-img.c9d4f119.svg";